interface IRecord {
  price: string;
  algo: string;
}

export interface IPNL {
  newText: string;
  zeroPrice: number;
  fixPrice: number;
  zeroDelta: number;
  fixDelta: number;
  course: number;
}

export const usePNL = ({ price = '', algo = '' }: IRecord): IPNL => {
    const [courseStr, fixPriceStr, zeroPriceStr] = price.split('\n');

    // Преобразуем строки в числа
    const fixPrice = Number(fixPriceStr);
    const zeroPrice = Number(zeroPriceStr);
    const course = Number(courseStr);

    let fixDelta = 0;
    let zeroDelta = 0;

    if (algo !== 'long') {
        fixDelta = -fixPrice + course;
        zeroDelta = -zeroPrice + course;
    } else {
        fixDelta = fixPrice - course;
        zeroDelta = zeroPrice - course;
    }

    const fixPerc = ((fixDelta / course) * 100).toFixed(2);
    const zeroPerc = ((zeroDelta / course) * 100).toFixed(2);
    const newText = `${course}\n${fixPrice} (${fixPerc}%)\n${zeroPrice} (${zeroPerc}%)`;

    return {
        newText,
        zeroPrice,
        fixPrice,
        zeroDelta,
        fixDelta,
        course,
    };
};